import HttpRequest from './http_request'

class ConfigProvider extends HttpRequest {
  constructor() {
    // api api
    super(process.env.VUE_APP_API_URL)
  }

  //===========================================================================
  //CONFIG_REGISTRATION_DATE_TIME
  async getConfigRegistrationDateTime() {
    const { data } = await this.get('/', {
      function: 'get-config',
      table: 'REGISTRATION_DATE_TIME',
      order: [{
        ID: 'DESC',
      }]
    })
    return data
  }

  async saveConfigRegistrationDateTime({
    level_id,
    sub_level_id,
    year,
    semester,
    start_datetime_system,
    start_datetime_academic,
    end_datetime_academic,
    start_datetime_config_teach_table,
    end_datetime_config_teach_table,
    start_datetime_midterm,
    end_datetime_midterm,
    start_datetime_final,
    end_datetime_final,
    start_datetime_pre_regis,
    end_datetime_pre_regis,
    start_datetime_regis,
    end_datetime_regis,
    start_datetime_add_change,
    end_datetime_add_change,
    start_datetime_withdraw,
    end_datetime_withdraw
  }) {
    const { data } = await this.create('/', {
      function: 'set-config',
      table: 'REGISTRATION_DATE_TIME',
      set: {
        LEVEL_ID: level_id,
        SUB_LEVEL_ID: sub_level_id,
        YEAR: year,
        SEMESTER: semester,
        START_DATETIME_SYSTEM: start_datetime_system,
        START_DATETIME_ACADEMIC: start_datetime_academic,
        END_DATETIME_ACADEMIC: end_datetime_academic,
        START_DATETIME_CONFIG_TEACH_TABLE: start_datetime_config_teach_table,
        END_DATETIME_CONFIG_TEACH_TABLE: end_datetime_config_teach_table,
        START_DATETIME_MIDTERM: start_datetime_midterm,
        END_DATETIME_MIDTERM: end_datetime_midterm,
        START_DATETIME_FINAL: start_datetime_final,
        END_DATETIME_FINAL: end_datetime_final,
        START_DATETIME_PRE_REGIS: start_datetime_pre_regis,
        END_DATETIME_PRE_REGIS: end_datetime_pre_regis,
        START_DATETIME_REGIS: start_datetime_regis,
        END_DATETIME_REGIS: end_datetime_regis,
        START_DATETIME_ADD_CHANGE: start_datetime_add_change,
        END_DATETIME_ADD_CHANGE: end_datetime_add_change,
        START_DATETIME_WITHDRAW: start_datetime_withdraw,
        END_DATETIME_WITHDRAW: end_datetime_withdraw
      }
    })
    return data
  }
  async editConfigRegistrationDateTime({
    LEVEL_ID: level_id,
    SUB_LEVEL_ID: sub_level_id,
    YEAR: year,
    SEMESTER: semester,
    START_DATETIME_SYSTEM: start_datetime_system,
    START_DATETIME_ACADEMIC: start_datetime_academic,
    END_DATETIME_ACADEMIC: end_datetime_academic,
    START_DATETIME_CONFIG_TEACH_TABLE: start_datetime_config_teach_table,
    END_DATETIME_CONFIG_TEACH_TABLE: end_datetime_config_teach_table,
    START_DATETIME_MIDTERM: start_datetime_midterm,
    END_DATETIME_MIDTERM: end_datetime_midterm,
    START_DATETIME_FINAL: start_datetime_final,
    END_DATETIME_FINAL: end_datetime_final,
    START_DATETIME_PRE_REGIS: start_datetime_pre_regis,
    END_DATETIME_PRE_REGIS: end_datetime_pre_regis,
    START_DATETIME_REGIS: start_datetime_regis,
    END_DATETIME_REGIS: end_datetime_regis,
    START_DATETIME_ADD_CHANGE: start_datetime_add_change,
    END_DATETIME_ADD_CHANGE: end_datetime_add_change,
    START_DATETIME_WITHDRAW: start_datetime_withdraw,
    END_DATETIME_WITHDRAW: end_datetime_withdraw
  }) {
    const { data } = await this.create('/', {
      function: 'set-config',
      table: 'REGISTRATION_DATE_TIME',
      set: {
        LEVEL_ID: level_id,
        SUB_LEVEL_ID: sub_level_id,
        YEAR: year,
        SEMESTER: semester,
        START_DATETIME_SYSTEM: start_datetime_system,
        START_DATETIME_ACADEMIC: start_datetime_academic,
        END_DATETIME_ACADEMIC: end_datetime_academic,
        START_DATETIME_CONFIG_TEACH_TABLE: start_datetime_config_teach_table,
        END_DATETIME_CONFIG_TEACH_TABLE: end_datetime_config_teach_table,
        START_DATETIME_MIDTERM: start_datetime_midterm,
        END_DATETIME_MIDTERM: end_datetime_midterm,
        START_DATETIME_FINAL: start_datetime_final,
        END_DATETIME_FINAL: end_datetime_final,
        START_DATETIME_PRE_REGIS: start_datetime_pre_regis,
        END_DATETIME_PRE_REGIS: end_datetime_pre_regis,
        START_DATETIME_REGIS: start_datetime_regis,
        END_DATETIME_REGIS: end_datetime_regis,
        START_DATETIME_ADD_CHANGE: start_datetime_add_change,
        END_DATETIME_ADD_CHANGE: end_datetime_add_change,
        START_DATETIME_WITHDRAW: start_datetime_withdraw,
        END_DATETIME_WITHDRAW: end_datetime_withdraw
      }
    })
    return data
  }
  async deleteConfigRegistrationDateTime({ id }) {
    const { data } = await this.delete('/', {
      function: 'delete-config',
      table: 'REGISTRATION_DATE_TIME',
      where: {
        ID: id,
      }
    })
    return data
  }
  //Config Teach_Table
  async getTeachTable({ faculty_id, department_id, curriculum_id, curriculum2_id, year, semester, year_class, section, subject_id }) {
    const { data } = await this.get('/', {
      function: 'get-teach-table',
      where: [{
        faculty_id: faculty_id,
        dept_id: department_id,
        curr_id: curriculum_id,
        curr2_id: curriculum2_id,
        year: year,
        semester: semester,
        class: year_class,
        section: section,
        subject_id: subject_id,
      }],
      order: [{
        section: 'ASC',
      }]
    })
    return data
  }
  async getTeachTableByTeachTableId(teach_table_id) {
    const { data } = await this.get('/', {
      function: 'get-teach-table',
      where: [{
        TEACH_TABLE_ID: teach_table_id,
      }],
      order: [{
        section: 'ASC',
      }]
    })
    return data
  }
  async getGraduateTeachTableByTeachTableId(teach_table_id) {
    const { data } = await this.get('/', {
      function: 'get-graduate-teach-table-config',
      teach_table_id,
    })
    return data
  }
  async saveTeachTable({
    teach_table_id,
    permission_faculty_id,
    schedule_details,
    input_subject_id,
    semester,
    year,
    program,
    section,
    limit,
    room_no,
    building_no,
    midterm_exam_day,
    midterm_exam_date,
    midterm_exam_time_start,
    midterm_exam_time_stop,
    final_exam_day,
    final_exam_date,
    final_exam_time_start,
    final_exam_time_stop,
    exam_type_id,
    lect_or_prac_id,
    remark,
    subject_type_id,
    subject_owner_id,
    teach_type_id,
    exam_text_id,
    exam_text_detail }) {
    const { data } = await this.update('/', {
      function: 'set-teach-table',
      teach_table_id: teach_table_id,
      permission_faculty_id,
      schedule_details,
      input_subject_id: input_subject_id,
      semester: semester,
      year: year,
      program: program,
      section: section,
      limit: limit,
      room_no: room_no,
      building_no: building_no,
      midterm_exam_day: midterm_exam_day,
      midterm_exam_date: midterm_exam_date,
      midterm_exam_time_start: midterm_exam_time_start,
      midterm_exam_time_stop: midterm_exam_time_stop,
      final_exam_day: final_exam_day,
      final_exam_date: final_exam_date,
      final_exam_time_start: final_exam_time_start,
      final_exam_time_stop: final_exam_time_stop,
      exam_type_id: exam_type_id,
      lect_or_prac_id: lect_or_prac_id,
      remark: remark,
      subject_type_id: subject_type_id,
      subject_owner_id: subject_owner_id,
      teach_type_id: teach_type_id,
      exam_text_id: exam_text_id,
      exam_text_detail: exam_text_detail,
    })
    return data
  }
  async saveGraduateTeachTable(payload) {
    const { data } = await this.update('/', {
      function: 'set-graduate-teach-table',
      ...payload,
    })
    return data
  }
  async deleteTeachTable({ faculty_id, department_id, curriculum_id, curriculum2_id, year, semester, year_class, section, subject_id }) {
    const { data } = await this.delete('/', {
      function: 'delete-teach-table',
      where: {
        faculty_id: faculty_id,
        dept_id: department_id,
        curr_id: curriculum_id,
        curr2_id: curriculum2_id,
        year: year,
        semester: semester,
        class: year_class,
        section: section,
        subject_id: subject_id,
      }
    })
    return data
  }

  async getTimeSlot({ level_id, teach_table_id }) {
    const { data } = await this.get('/', {
      function: 'get-time-slot',
      level_id,
      teach_table_id
    })
    return data
  }
  async getTimeSlotPreset({ level_id, semester, year }) {
    const { data } = await this.get('/', {
      function: 'get-time-slot-preset',
      level_id,
      semester,
      year
    })
    return data
  }

  async setTimeSlot({ level_id, teach_table_id, all_time_slot }) {
    const { data } = await this.update('/', {
      function: 'set-time-slot',
      level_id,
      teach_table_id,
      all_time_slot,
    })
    return data
  }

  async getRuleSlot({ level_id, teach_table_id }) {
    const { data } = await this.get('/', {
      function: 'get-rule-slot',
      level_id,
      teach_table_id
    })
    return data
  }
  async setRuleSlot({ level_id, teach_table_id, all_rule_slot }) {
    const { data } = await this.update('/', {
      function: 'set-rule-slot',
      level_id,
      teach_table_id,
      all_rule_slot,
    })
    return data
  }

  async getTeachTableAppear({ level_id = 1, year = null, semester = null, teach_table_id }) {
    const { data } = await this.get('/', {
      function: 'get-teach-table-appear',
      level_id,
      year,
      semester,
      teach_table_id
    })
    return data
  }
  async setTeachTableAppear({ level_id = 1, year, semester, teach_table_id, all_teach_table_appear }) {
    const { data } = await this.update('/', {
      function: 'set-teach-table-appear',
      level_id,
      YEAR: year,
      SEMESTER: semester,
      teach_table_id,
      TEACH_TABLE_ID: teach_table_id,
      all_teach_table_appear,
    })
    return data
  }

  async getTeachTableId({
    faculty_id,
    department_id,
    curriculum_id,
    curriculum2_id,
    subject_id,
    semester,
    year,
    year_class,
    section
  }) {
    const { data } = await this.get('/', {
      function: 'get-teach-table-id',
      faculty_id,
      department_id,
      curriculum_id,
      curriculum2_id,
      subject_id,
      semester,
      year,
      year_class,
      section
    })
    return data
  }

  async getBuildingFromTeachTable(TEACH_TABLE_ID, LEVEL_ID = 1) {
    const { data } = await this.get('/', {
      function: 'get-building-room',
      TEACH_TABLE_ID,
      LEVEL_ID
    })
    return data
  }

  async setBuildingFromTeachTable(TEACH_TABLE_ID, building_no, room_no, LEVEL_ID = 1) {
    const { data } = await this.update('/', {
      function: 'set-building-room',
      TEACH_TABLE_ID, building_no, room_no, LEVEL_ID
    })
    return data
  }
}

export default ConfigProvider
